export default "__VITE_ASSET__ac20f415__"